import React from 'react';
import SpellEntry from './SpellEntry'


let SpellList = ({spells})=> {


  if (spells) {
    return(
      <div className="spell-list">
        <table className="spell-list-table">
          <thead>
            <tr className="spell-header">
              <th>Spell Name</th>
              <th>Spell School</th>
              <th>Level</th>
              <th>Description</th>
              <th>Source Book</th>
            </tr>
          </thead>
          <tbody>
            {spells.map(spell => (
              <SpellEntry spell={spell} key={spell.spell_id}/>
            ))}
          </tbody>
        </table>
      </div>
    )
  } else {
    return (<div className="spell-list"></div>)
  }

}

export default SpellList